"use strict";

export const galleryMixin = {
    mounted: function () {
        const _self = this;
        document.querySelectorAll('.open-gallery').forEach((el, idx) => {
            const img = el.getElementsByTagName('img')[0];
            const figcaption = el.getElementsByTagName('figcaption')[0];
            _self.gallery.push({
                src: img.dataset.original ? img.dataset.original : (img.dataset.src ? img.dataset.src : img.src),
                alt: img.alt,
                title: img.title,
                description: img.dataset.description,
                caption: img.dataset.caption ? img.dataset.caption : (figcaption ? figcaption.innerHTML : null)
            });
            el.addEventListener('click', function () {
                _self.openGallery(idx);
            });
            document.addEventListener("keyup", this.keyup);
        })
    },
    data: function () {
        return {
            gallery: [],
            selectedIdx: -1,
            p: false,
            n: false
        };
    },
    computed: {
        selectedImage: function () {
            const ret = this.selectedIdx > -1 ? this.gallery[this.selectedIdx] : null;
            if (ret) {
                document.body.classList.add("overflow-hidden");
            } else {
                document.body.classList.remove("overflow-hidden");
            }
            return ret;
        }
    },
    methods: {
        openGallery: function (idx) {
            this.selectedIdx = idx;
        },
        closeGallery: function () {
            this.selectedIdx = -1;
        },
        keyup: function (event) {
            if (event.isComposing || event.keyCode === 229) {
                return;
            }
            if (this.selectedImage) {
                if (event.keyCode == 37) {
                    this.p = true;
                    setTimeout(() => {
                        this.p = false;
                    }, 100);
                    this.prev();
                }
                if (event.keyCode == 39) {
                    this.n = true;
                    setTimeout(() => {
                        this.n = false;
                    }, 100);
                    this.next();
                }
                if (event.keyCode == 27) {
                    this.closeGallery();
                }
            } else {
                if (event.keyCode == 71 && event.altKey) {
                    this.openGallery(0);
                }
            }
        },
        next: function () {
            if (this.gallery.length > this.selectedIdx + 1) {
                this.selectedIdx++;
            } else {
                this.selectedIdx = 0;
            }
        },
        prev: function () {
            if (this.selectedIdx - 1 < 0) {
                this.selectedIdx = this.gallery.length - 1;
            } else {
                this.selectedIdx--;
            }
        }
    }
};